import React, { useState } from 'react';
import { Layout, Button } from 'antd';
const { Content } = Layout;

import withAuth from '~/libs/withAuth';
import { BlockLayout, ContentLayout, MainBlockLayout } from '~/components/layouts';
import SalesList from '~/components/InvoiceList';
import UploadDrop from '~/components/UploadDrop';
import InvoiceModal from '~/components/InvoiceModal';
import styled from 'styled-components';

const UploadBlockLayout = styled(BlockLayout)`
	margin-left: 50%;
	transform: translateX(-50%);
	margin-bottom: 20px;
	width: 90%;
`;

const Invoices = (props) => {
	const [ showUploads, setShowUploads ] = useState(false);
	const [ invoice, setInvoice ] = useState(null);

	const jsxActions = <>
		<Button key='btn-invoice-uploads' type="primary" onClick={() => setShowUploads(!showUploads)}>
			{showUploads ? 'Close Uploads' : 'Open Uploads'}
		</Button>
	</>;

	return (
		<ContentLayout>
			<MainBlockLayout title='Invoices' actions={jsxActions}>
				
				{showUploads && <UploadBlockLayout style={{ marginTop: -21 }} 
					contentStyle={{ borderTop: 'none', padding: '0 10px 10px 10px' }}>
					<UploadDrop mode='invoices' />
				</UploadBlockLayout>}

				<BlockLayout size='8' contentStyle={{ padding: 0 }}>
					<SalesList onEditClick={(e) => { setInvoice(e) }} />
				</BlockLayout>

      </MainBlockLayout>

			<InvoiceModal invoice={invoice} onClose={() => setInvoice(null)} />

		</ContentLayout>
	);

};

export default withAuth(Invoices);